import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=3676e118&scoped=true&"
import script from "./talk.vue?vue&type=script&lang=js&"
export * from "./talk.vue?vue&type=script&lang=js&"
import style0 from "./talk.vue?vue&type=style&index=0&id=3676e118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676e118",
  null
  
)

export default component.exports